import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpOverviewKeys = {
  all: ['analytics', 'fp-overview'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpOverviewKeys.all, 'list', params] as const,
};

export const useFPOverviewData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpOverviewKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPOverview(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
